import React, { useState, useEffect, message } from "react";
import { Form, Col, Row, Button, Input } from "antd";
import RequestHandler from "util/RequestHandler";
import { SendOutlined } from "@ant-design/icons";
const formItemLayout = {
    labelCol: {
        xs: {
            span: 24,
        },
        sm: {
            span: 8,
        },
    },
    wrapperCol: {
        xs: {
            span: 24,
        },
        sm: {
            span: 16,
        },
    },
};
const { TextArea } = Input;
const PosCollectionTransactionCancelModal = (props) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({});
    const [form] = Form.useForm();

    useEffect(() => {
        if (props.data) {
            form.setFieldsValue(props.data);
            setData(props.data);
        }
    }, [props.data]);

    const onFinish = (values) => {
        RequestHandler.post(
            `/PosCollection/CancelPosProcess`,
            {
                id: data.id,
                cancelNote:values.cancelNote
            },
            true
        ).then((response) => {
            if (response.success) {
                if (props.onSuccess) props.onSuccess();
            }
            setLoading(false);
        });
    };

    const onFinishFailed = (errorInfo) => {
        setLoading(false);
    };
    return (
        <>
            <Form
                {...formItemLayout}
                form={form}
                name="posCollectionCancelModal"
                initialValues={{
                    remember: true,
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
            >
                <Row>
                    <Col span={24}>
                        <Form.Item label="İptal Notu" name="cancelNote">
                            <TextArea
                                autoSize={{ minRows: 3, maxRows: 5 }}
                            />
                        </Form.Item>
                        <Row justify="end" style={{ marginRight: "4%" }}>
                            <Col>
                                <Button
                                    type="primary"
                                    icon={<SendOutlined />}
                                    htmlType="submit"
                                    onClick={() => setLoading(true)}
                                    loading={loading}
                                >
                                    {"İptal Et"}
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Form>
        </>
    );
};
export default PosCollectionTransactionCancelModal;
